<template lang='pug'>
    .columns.is-vcentered.is-mobile
      .container.column.p0
        .columns.is-centered
          .column.is-half
            h1.has-text-centered {{$t('componentes.coletor.views.criarColetor.titulo')}}
        .columns.is-centered
          .column.is-half
            InputText(
              v-focus="",
              v-model.trim="nome",
              autocomplete="off",
              pattern=".{3,}",
              required="true",
              :label="$t('componentes.coletor.views.criarColetor.labelDoInput')"
            )
        .columns.is-centered(v-if="perfisDeColetor.length && !ehFuncionario")
          .column.is-half
            PSelect(
              :titulo="$t('componentes.coletor.views.criarColetor.labelDoSeletor')"
              :opcoes="perfisDeColetor"
              :opcaoPadrao="perfilColetorPadrao"
              opcaoRef="nome"
              @opcaoSelecionada="selecionarPerfil"
              :faltaItems="faltaPerfis"
              @buscarMaisItems="buscarMaisPerfis"
            )
        .columns.is-centered(v-if="!ehFuncionario")
          .column.is-half
            .titulo {{$t('componentes.coletor.views.criarColetor.paraQuem.label')}}:
            .seletor
              .seletor-item
                input(type='radio', value='individual', v-model='modo' id="individual")
                label.to-click(for="individual") {{$t('componentes.coletor.views.criarColetor.paraQuem.opcoes.empregado')}}
              .seletor-item
                input(type='radio', value='equipe', v-model='modo' id="equipe")
                label.to-click(for="equipe") {{$t('componentes.coletor.views.criarColetor.paraQuem.opcoes.grupo')}}
              .seletor-item
                input(type='radio', value='todos', v-model='modo' id="todos")
                label.to-click(for="todos") {{$t('componentes.coletor.views.criarColetor.paraQuem.opcoes.todos')}}

        .columns.is-centered(v-if="!ehFuncionario && modo === 'individual'")
          .column.is-half
            PSelect(
              :titulo="$t('componentes.coletor.views.criarColetor.seletorEntidadeEmpregado.label')"
              :permiteFiltro="true"
              :opcoes="empregados"
              opcaoRef="nome"
              @opcaoSelecionada="selecionarEmpregado"
              :faltaItems="faltaEmpregados"
              @buscarMaisItems="buscarEmpregados"
              @parametroBusca="buscarEmpregados"
            )
        .columns.is-centered(v-if="modo === 'equipe' && !ehFuncionario")
          .column.is-half
              MultiSeletor(
                :label="$t('componentes.coletor.views.criarColetor.seletorEntidadeGrupo.label')"
                maxHeight="120px"
                :items="locaisDeTrabalho"
                itemRef="nome"
                @checkedValues="coletaLocais"
                :filterLabel="$t('componentes.coletor.views.criarColetor.seletorEntidadeGrupo.placeholder')"
              )
        .columns.is-centered(v-if="modo || ehFuncionario")
          .column.is-half
            Button3d(@click="prosseguir" color="success", size="large", :block="true") {{$t('componentes.coletor.views.criarColetor.botaoSelecionar')}}

</template>

<script>
import MultiSeletor from '@/common/Seletores/MultiSeletor'
import PSelect from '@/common/Seletores/PSelect'
import { validarCamposCriarColetor } from '../utils'

export default {
  computed: {
    modo: {
      get () {
        return this.$store.state.coletor.criarColetor.modo
      },
      set (value) {
        this.$store.commit('coletor/atribuiModoCriarColetor', value)
      }
    },
    nome: {
      get () {
        return this.$store.state.coletor.criarColetor.nome
      },
      set (value) {
        this.$store.commit('coletor/atribuiNomeCriarColetor', value)
      }
    },
    ehFuncionario () {
      return this.$store.state.coletor.criarColetor.ehFuncionario
    },
    empregados () {
      return this.$store.state.coletor.criarColetor.empregados.lista
    },
    perfisDeColetor ()  {
      return this.$store.state.coletor.perfisDeColetor.lista
    },
    perfilColetorPadrao () {
      return this.$store.state.coletor.perfisDeColetor.perfilPadrao
    },
    locaisDeTrabalho () {
      return this.$store.getters['coletor/locaisDeTrabalhoIdENome']
    },
    loading () {
      return this.$store.state.coletor.loading
    },
    faltaPerfis () {
      return this.$store.state.coletor.perfisDeColetor.faltaPerfis
    },
    faltaEmpregados () {
      return this.$store.state.coletor.criarColetor.empregados.faltaEmpregados
    }
  },
  methods: {
    coletaLocais (event) {
      this.$store.commit('coletor/atribuiLocaisCriarColetor', { selecionado: event })
    },
    selecionarPerfil (event) {
      this.$store.commit('coletor/atribuiPerfilDeColetorSelecionado', event)
    },
    selecionarEmpregado (event) {
      this.$store.commit('coletor/atribuiEmpregadosCriarColetor', { selecionado: event })
    },
    buscarMaisPerfis () {
      this.$store.dispatch('coletor/buscarPerfisDeColetor')
    },
    buscarEmpregados (event) {
      this.$store.commit('coletor/atribuiEmpregadosCriarColetor', { filtro: event ? event.toLowerCase() : '' })
      this.$store.dispatch('coletor/buscarEmpregados')
    },
    prosseguir () {
      const temErro = validarCamposCriarColetor()
      if (temErro) return
      this.$router.push({ name: 'confirmacaoInfoColetor' })
    }
  },
  components: {
    MultiSeletor,
    PSelect
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-list li {
  padding-left: 0.375rem;
  font-size: 0.75rem;
}
.seletor {
  display: flex;
  flex-direction: column;
  align-items: left;
}
.seletor-item {
  margin-bottom: 0.5rem;
}
.seletor-item label{
  padding-left: 0.375rem;
}

.titulo {
  font-weight: 700;
  margin-bottom: 0.5rem;
}
</style>
